<template src="./slidebar.html"></template>

<script>
import SlidebarService from 'Services/SlidebarService';

export default {
  data() {
    return {
      slideBars: [],
      slide: 0,
      sliding: null,
    };
  },

  created() {
    this.listSlideBars();
  },

  methods: {
    onSlideStart() {
      this.sliding = true;
    },

    onSlideEnd() {
      this.sliding = false;
    },

    listSlideBars() {
      SlidebarService.listClient()
        .then((response) => {
          this.slideBars = response.data;
        })
        .catch(() => {
        });
    },
  },
};
</script>
